import styled from 'styled-components';
import ReactPaginate from 'react-paginate';

export const GalleryContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100%;
position: relative;
`;

export const GalleryWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 50px 25px;
`;

export const GalleryImageWrapper = styled.div`
display: grid;
width: 100%;
grid-template-columns: repeat(3, 1fr);
grid-gap: 50px;
justify-content: space-between;
align-items: center;

@media screen and (max-width: 1200px){
    grid-template-columns: repeat(2, 1fr);
}

@media screen and (max-width: 768px){
    grid-template-columns: repeat(1, 1fr);
}
`;

export const NoWalletWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
justify-content: center;
align-items: center;
gap: 10px;
`;

export const NoWalletTextWrapper = styled.div`
background: #fff;
padding: 50px;
text-align: center;
border-radius: 25px;
box-shadow: 5px 5px rgba(136, 136, 136, 0.1);
`;

export const NoWalletTextBig = styled.p`
font-size: 28px;
font-weight: bold;

@media screen and (max-width: 768px){
    font-size: 24px;
}

@media screen and (max-width: 480px){
    font-size: 18px;
}
`;

export const NoWalletTextSmall = styled.p`
font-size: 18px;

@media screen and (max-width: 768px){
    font-size: 16px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
}
`;

export const CardInfotext = styled.p`
position: absolute;
text-align: center;
text-decoration: none;
color: #000;
font-size: 0px;
transform: translate(-50%, -50%);
top: 50%;
left: 50%;
background: #fff;
width: 100%;
`;

export const GalleryCard = styled.div`
display: flex;
flex-direction: column;
position: relative;
border-radius: 10px;
width: 100%;
transition: all 0.2s ease-in-out;
box-shadow: 10px 10px rgba(136, 136, 136, 0.1);

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    cursor: pointer;
    box-shadow: 15px 15px rgba(136, 136, 136, 0.2);
}

&:hover ${CardInfotext} {
    transition: 0.2s all ease-in-out;
    font-size: 28px;

    @media screen and (max-width: 1200px){
        font-size: 24px;
    }

    @media screen and (max-width: 768px){
        font-size: 18px;
    }

    @media screen and (max-width: 480px){
        font-size: 16px;
    }
}
`;

export const CardImage = styled.img`
width: 100%;
height: auto;
border-radius: 10px;
`;

export const CardNftID = styled.p`
font-size: 24px;
position: absolute;
z-index: 2;
left: 15px;
bottom: 3%;
color: #fff;
font-weight: bold;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;

export const GalleryHeader = styled.h1`
font-size: 36px;
text-align: center;
margin-bottom: 25px;

@media screen and (max-width: 768px){
    font-size: 24px;
}

@media screen and (max-width: 480px){
    font-size: 18px;
}
`;

export const GalleryAmountText = styled.h3`
font-size: 24px;
margin-bottom: 25px;

@media screen and (max-width: 768px){
    font-size: 18px;
}

@media screen and (max-width: 480px){
    font-size: 16px;
}
`;

export const PaginateButton = styled.button`
display: flex;
width: fit-content;
height: fit-content;
padding: 5px;
background: linear-gradient(215deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
color: #fff;
border-radius: 5px;
border: none;
justify-content: center;
align-items: center;
font-size: 20px;

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    background: linear-gradient(45deg, rgba(51,104,44,1) 0%, rgba(97,150,87,1) 100%);
    cursor: pointer;
}
`;

export const MyPaginate = styled(ReactPaginate).attrs({
  // You can redifine classes here, if you want.
  activeClassName: 'active', // default to "disabled"
})`
    margin-bottom: 1rem;
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    list-style-type: none;
    margin-left: auto;
    margin-right: auto;
    li {
      padding: 3px;
    }
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
    }
    li.previous a,
    li.next a,
    li.break a {
      border-color: transparent;
    }
    li.active a {
      background-color: #33682c;
      border-color: transparent;
      color: white;
      min-width: 32px;
    }
    li.disabled a {
      color: grey;
    }
    li.disable,
    li.disabled a {
      cursor: default;
    }
  `;
